import styled from 'styled-components';

const InputWithUnit = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  > input {
    flex: 1;
    margin: 0;
  }
  > span {
    padding-left: 10px;
  }
`;

export default InputWithUnit;
